import React, { useState } from "react";
import styles from "./EmailInvoiceModal.module.scss";
import classNames from "classnames/bind";
import { IPayloadEmailInvoice } from "~/utils/interface/jobDetails";
import BaseModalV2 from "~/components/common/base-modal-v2/BaseModalV2";
import PrimaryButton from "~/components/common/primary-button/PrimaryButton";
import jobDetailsApi from "~/apis/jobDetails";
import { notify } from "~/utils/helper";

const cx = classNames.bind(styles);

export interface IEmailInvoiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  customer: any;
  invoiceId: string;
}

const EmailInvoiceModal = ({
  isOpen,
  onClose,
  customer,
  invoiceId,
}: IEmailInvoiceModalProps) => {
  const [formData, setFormData] = useState<IPayloadEmailInvoice>({
    flagSendEmailToCustomer: false,
    invoiceId: Number(invoiceId),
    emails: [],
  });
  const [emailInput, setEmailInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSendEmail = async () => {
    const emailsArray = emailInput
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email.length > 0);

    if (!formData.flagSendEmailToCustomer && emailsArray.length === 0) {
      setError("Please check the customer checkbox or enter at least one email address");
      return;
    }

    setError("");
    setIsLoading(true);
    try {
      const payload = {
        ...formData,
        emails: emailsArray,
      };
      await jobDetailsApi.emailInvoice(payload);
      notify('success', 'Email sent successfully');
      onClose();
    } catch (error: any) {
      notify('error', error.response.data.message || 'Something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <BaseModalV2
      open={isOpen}
      onClose={onClose}
      title="Email Invoice"
      width="90%"
      maxWidth="500px"
    >
      <div className={cx("email-invoice-modal-container")}>
        <h2 className={cx("title")}>
          Select the recipient(s) from the list below
        </h2>

        <div className={cx("customer-container")}>
          <input
            type="checkbox"
            checked={formData.flagSendEmailToCustomer}
            onChange={(e) => {
              setFormData({
                ...formData,
                flagSendEmailToCustomer: e.target.checked,
              });
              setError("");
            }}
          />{" "}
          <span>
            {customer?.name || "N/A"} ({customer?.email || "N/A"})
          </span>
        </div>

        <div className={cx("email-container")}>
          <label className={cx("email-label")}>
            Additional Recipients (Separate multiple email addresses with a
            comma)
          </label>
          <textarea
            className={cx("email-textarea")}
            placeholder="Enter email addresses"
            value={emailInput}
            onChange={(e) => {
              setEmailInput(e.target.value);
              setError("");
            }}
          />
          {error && <div className={cx("error-message")}>{error}</div>}
        </div>

        <div className={cx("button-container")}>
          <PrimaryButton
            title="Cancel"
            onClick={onClose}
            className={cx("cancel-button")}
            disabled={isLoading}
          />
          <PrimaryButton
            title="Send"
            onClick={handleSendEmail}
            className={cx("send-button")}
            loading={isLoading}
          />
        </div>
      </div>
    </BaseModalV2>
  );
};

export default EmailInvoiceModal;
